import { render, staticRenderFns } from "./ProductList1.vue?vue&type=template&id=0b032790&scoped=true&"
import script from "./ProductList1.vue?vue&type=script&lang=js&"
export * from "./ProductList1.vue?vue&type=script&lang=js&"
import style0 from "./ProductList1.vue?vue&type=style&index=0&id=0b032790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b032790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b032790')) {
      api.createRecord('0b032790', component.options)
    } else {
      api.reload('0b032790', component.options)
    }
    module.hot.accept("./ProductList1.vue?vue&type=template&id=0b032790&scoped=true&", function () {
      api.rerender('0b032790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Content/components/ProductList1.vue"
export default component.exports